import { Injectable } from '@angular/core';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';
import { Parcours } from 'src/app/shared/models/services-aide-emploi/parcours';
import { Observable } from 'rxjs';
import { Mission } from 'src/app/shared/models/mission/mission';
import { Employee } from 'src/app/shared/models/employee/employee';

@Injectable({
	providedIn: 'root'
})
export class ParcoursService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 * Renvoi la liste de tous les parcours
	 * @returns
	 */
	getParcours(): Observable<Parcours[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.parcoursUrl}`,
			'getParcours'
		);
	}

	importParcoursFromOcashe(): Observable<void> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.parcoursUrl}/import`,
			'importParcoursFromOcashe'
		);
	}

	getParcoursById(parcoursId: string): Observable<Parcours> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.parcoursUrl}/${parcoursId}`,
			'getParcoursById'
		);
	}

	postQualificationMission(
		parcoursId: string,
		mission: Mission
	): Observable<Parcours> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.parcoursUrl}/${parcoursId}`,
			'postQualificationMission',
			mission
		);
	}

	searchBestEmployees(requiredDataForSearch): Observable<Employee[]> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.parcoursUrl}/employees`,
			'searchBestEmployees',
			requiredDataForSearch
		);
	}

	postQualificator(
		parcoursId: string,
		employee: Employee
	): Observable<Parcours> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.parcoursUrl}/${parcoursId}/qualification`,
			'postQualificator',
			employee
		);
	}
}
